import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useFetch, { CachePolicies } from 'use-http'
import useToast from '../../../hooks/useToast'
import { MLContext, UserContext } from '../../../providers'
import { MediaLibraryActions } from '../../../providers/MLProvider'

const PollUnseenNotificationsCount = (): null => {
  const { t } = useTranslation()
  const { request } = useFetch({
    cachePolicy: CachePolicies.NO_CACHE,
  })
  const [, dispatch] = useContext(MLContext)
  const { user } = useContext(UserContext)
  const toast = useToast()

  const getUnseenNotificationsCount = async (): Promise<void> => {
    const res = (await request.get(
      `/api/media-library/${user?.clientNumber}/notifications/count/unseen`,
    )) as { count: number }

    if (request.error) {
      dispatch([
        {
          type: MediaLibraryActions.SET_UNSEEN_NOTIFICATIONS_COUNT,
          payload: 0,
        },
      ])
      toast({
        description: t(
          'unseen_notifications_count_failed_description',
          'An error occured in unseen notifications count.',
        ),
        status: 'error',
        isClosable: true,
        duration: 5000,
        position: 'top-right',
        variant: 'outline',
      })
    } else if (res) {
      dispatch([
        {
          type: MediaLibraryActions.SET_UNSEEN_NOTIFICATIONS_COUNT,
          payload: res.count,
        },
      ])
    }
  }

  useEffect(() => {
    void getUnseenNotificationsCount()
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      void getUnseenNotificationsCount()
    }, 10000)

    return () => void clearInterval(interval)
  }, [])

  return null
}

export default PollUnseenNotificationsCount
